"use strict";

jQuery(document).ready(function ($) {
  $('.product-information__group--title').on('click', function () {
    var dropTitle = $(this);
    var drop = dropTitle.closest('.product-information__group--drop');
    drop.toggleClass('open');
  });
});